import { render, staticRenderFns } from "./realPaySuccess.vue?vue&type=template&id=bfab21d2&scoped=true&"
import script from "./realPaySuccess.vue?vue&type=script&lang=ts&"
export * from "./realPaySuccess.vue?vue&type=script&lang=ts&"
import style0 from "./realPaySuccess.vue?vue&type=style&index=0&id=bfab21d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfab21d2",
  null
  
)

export default component.exports